import React from "react"
import { graphql, useStaticQuery, Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import * as styles from "../styles/sidebar.module.css"

const Sidebar = () => {
  const data = useStaticQuery(graphql`
    query {
      allMarkdownRemarkCategory: allMarkdownRemark {
        group(field: { frontmatter: { categories: { slug: SELECT } } }) {
          fieldValue
        }
      }
      allMarkdownRemarkTag: allMarkdownRemark {
        group(field: { frontmatter: { tags: { slug: SELECT } } }) {
          fieldValue
        }
      }
      allCategoryJson {
        nodes {
          id
          slug
          title
        }
      }
      allTagJson {
        nodes {
          id
          slug
          title
        }
      }
    }
  `)

  return (
    <aside id="sidebar" className="l-sidebar">
      <div className="c-widget">
        <div className={styles.profileBox}>
          <figure>
            <StaticImage
              src="../images/bg-profile.png"
              alt="*"
              className={styles.profileBox__bg}
            />
          </figure>
          <figure className={styles.profileBox__icon}>
            <StaticImage
              src="../images/profile.png"
              alt="yuko"
              className={styles.profileBox__iconImg}
            />
            <figcaption>yuko shinmachi</figcaption>
          </figure>
          <p>
            27歳でフランスに語学留学、30歳でワーホリ。現在は貿易関係の仕事をしながらフランス語の翻訳や通訳も時々やっている、末端の仏語学習者です。
          </p>
        </div>
      </div>
      <div className="c-widget widget_categories">
        <h2 className="c-widget__title">カテゴリー</h2>
        <ul>
          {data.allCategoryJson.nodes
            .filter(node =>
              data.allMarkdownRemarkCategory.group
                .map(group => group.fieldValue)
                .includes(node.slug)
            )
            .map(node => (
              <li key={node.id} className="cat-item">
                <Link to={`/category/${node.slug}/`}>{node.title}</Link>
              </li>
            ))}
        </ul>
      </div>
      <div className="c-widget">
        <h2 className="c-widget__title">タグ</h2>
        <p className="tagcloud">
          {data.allTagJson.nodes
            .filter(node =>
              data.allMarkdownRemarkTag.group
                .map(group => group.fieldValue)
                .includes(node.slug)
            )
            .map(node => (
              <Link
                key={node.id}
                className="tag-cloud-link"
                aria-label={node.title}
                to={`/tag/${node.slug}/`}
              >
                {node.title}
              </Link>
            ))}
        </p>
      </div>
    </aside>
  )
}

export default Sidebar
